
import React, { useEffect, useState } from "react";
import axios from "axios";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import Config from "../../config.js";
import { useForm, Controller } from "react-hook-form";
import MDBox from "components/MDBox";
import { Card, TextField, Backdrop, Grid, Autocomplete, MenuItem, Tooltip, InputAdornment, Icon, CircularProgress } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDEditor from "components/MDEditor/index.js";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import TreeSelect from "components/TreeSelect";
import { SERVICE, PRIVILEGE } from 'constants.js';
import { useContext } from 'react';
import configurationContext from "contextConfig.js";
import MediaUpload from "layouts/components/MediaUpload.js";
import { handleSearchShopName, convertToTree, processCustomFields } from "common.js";
import CountryOfOrigin from "layouts/components/CountryOfOrigin.js";
import CustomFields from "layouts/components/CustomFields.js";
import { handleErrors, manipulateDataForDefaultSelected, reorder, convertToBase64, checkPrivilege } from "common.js";
import Section from "./Section.js";

function Service() {
    const { productId } = useParams();
    const product_Id = productId ? productId : 0;
    const addPage = (typeof (productId) == 'undefined') ? true : false;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const BASE = Config.BASE;
    const TOKEN = window.localStorage.getItem('token');
    const MyContext = useContext(configurationContext);
    const [isLoading, setIsLoading] = useState(false);
    const [responseData, setResponseData] = useState([]);
    const [shopNameList, setShopNameList] = useState([]);
    const [description, setDescription] = useState('');
    const adminType = localStorage.getItem("type");
    const [loading, setLoading] = useState(false);
    const [collections, setCollections] = useState([]);
    const [collectionId, setCollectionId] = useState([]);
    const [mediaList, setMediaList] = useState([]);
    const [mediaLoading, setMediaLoading] = useState(false);
    const [variantMediaLoading, setVariantMediaLoading] = useState(false);
    const [urlPopup, setUrlPopup] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [mediaImages, setMediaImages] = useState([]);
    const [imagePopup, setImagePopup] = useState(false);
    const [startIndex, setStartIndex] = useState(0);
    const [selectedCountryOfOrgin, setSelectedCountryOfOrgin] = useState();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [customFields, setCustomFields] = useState([]);
    const [categoryCustomFields, setCategoryCustomFields] = useState([])
    const [categories, setCategories] = useState([]);
    const [sectionLoading, setSectionLoading] = useState(true);
    const [pageReset, setPageReset] = useState(false);
    const [selectedCustomMultiselect, setSelectedCustomMultiselect] = useState([]);
    const [sectionId, setSectionId] = useState(1);
    const [topicId, setTopicId] = useState(1);
    const [sections, setSections] = useState([
        {
            id: "section0",
            title: "",
            description: "",
            duration: 0,
            hidden: false,
            topics: [{ id: "topic0", title: "", description: "", fileInfo: {}, duration: 0, freePreview: false, hidden: true }]
        }
    ]);

    const { register, handleSubmit, watch, control, formState, formState: { errors }, setValue, getValues, setError, trigger, reset,
    } = useForm({
        defaultValues: {
        }
    });

    const fetchProductCreationData = async () => {
        setIsLoading(true);
        axios.get(BASE + 'api/product/fetch-product-creation-data?dataFrom=service', {
            headers: {
                Authorization: `Bearer ${TOKEN}`,
                function: Config.FUNCTION_KEY,
            }
        }).then((response) => {
            setIsLoading(false);
            if (response.status == 200) {
                setSectionLoading(false)
                const status = response.data.status;
                const message = response.data.message;
                if (status == 1) {
                    let responseData = response.data.data;
                    const convertedData = convertToTree(responseData.collections);
                    setCollections(convertedData);
                    setCategories(responseData.categories);
                    setCustomFields(responseData.generalCustomFields);
                }
                else {
                    if (message != '') {
                        toast.error(t(message));
                        const redirectTimeout = setTimeout(() => {
                            clearTimeout(redirectTimeout);
                            navigate('/services/manage')
                        }, 3000);
                    }
                }
            }
            else {
                toast.error(t('unableToProccessRequest'));
                const redirectTimeout = setTimeout(() => {
                    clearTimeout(redirectTimeout);
                    navigate('/services/manage')
                }, 3000);
            }
        }).catch(error => {
            setIsLoading(false);
            handleErrors(error, t, navigate);
        });
    }

    const fetchData = async () => {
        setIsLoading(true);
        axios.get(BASE + 'api/service/view/' + product_Id, {
            headers: {
                Authorization: `Bearer ${TOKEN}`,
                function: Config.FUNCTION_KEY,
            }
        })
            .then((response) => {
                setIsLoading(false);
                const requestStatus = response.status;
                if (requestStatus == 200) {
                    const status = response.data.status;
                    const message = response.data.message;
                    if (status == 1) {
                        const responseData = response.data.data;
                        setResponseData(responseData);
                        const responseDataDetails = response.data.data.details;
                        if (responseDataDetails.vendorId) {
                            setValue('vendorId', responseDataDetails.vendorId)
                        }
                        setValue('gstSlab', (responseDataDetails.gstSlab) ? responseDataDetails.gstSlab : 0)
                        if (responseDataDetails.vendorShopName != null || responseDataDetails.vendorShopName != '')
                            setValue('vendorShopName', responseDataDetails.vendorShopName)
                        if (responseDataDetails.title != null || responseDataDetails.title != '')
                            setValue('title', responseDataDetails.title)
                        if (responseDataDetails.description != null && responseDataDetails.description != '')
                            setDescription(responseDataDetails.description);
                        if (responseDataDetails.tags != null && responseDataDetails.tags != '')
                            setValue('tags', responseDataDetails.tags);
                        if (responseData.generalCustomFields.length > 0) {
                            setCustomFields(responseData.generalCustomFields);
                            let value = responseData.generalCustomFields;
                            value.map((item) => {
                                if (item.fieldType == 6) {
                                    setSelectedCustomMultiselect((selectedCustomMultiselect) => ({
                                        ...selectedCustomMultiselect,
                                        [item.fieldName]: item.value,
                                    }));
                                }
                            })
                        }
                        if (responseData.categoryCustomFields.length > 0) {
                            setCategoryCustomFields(responseData.categoryCustomFields);
                            let value = responseData.categoryCustomFields;
                            value.map((item) => {
                                if (item.fieldType == 6) {
                                    setSelectedCustomMultiselect((selectedCustomMultiselect) => ({
                                        ...selectedCustomMultiselect,
                                        [item.fieldName]: item.value,
                                    }));
                                }
                            })
                        }
                        if (responseDataDetails.collections != null && responseDataDetails.collections != '') {
                            const convertedData = convertToTree(responseData.collectionArray);
                            setCollectionId(JSON.parse(responseDataDetails.collections));
                            manipulateDataForDefaultSelected(convertedData, responseDataDetails.collections);
                            setCollections(convertedData);
                        }
                        else {
                            const convertedData = convertToTree(responseData.collectionArray);
                            setCollections(convertedData);
                        }
                        if (responseDataDetails.images != null && responseDataDetails.images != '') {
                            let images = [];
                            images = JSON.parse(responseDataDetails.images).map(item => ({ original: item.mediaURL, thumbnail: '' }));
                            setMediaImages(images);
                            setMediaList(JSON.parse(responseDataDetails.images));
                        }
                        if (responseDataDetails.serviceInfo != null && responseDataDetails.serviceInfo != '') {
                            setSectionLoading(false)
                            let serviceInfo = JSON.parse(responseDataDetails.serviceInfo);
                            setSections(serviceInfo);
                            let highestSectionValue = -1;
                            let highestTopicValue = -1;
                            serviceInfo.forEach((section) => {
                                const sectionId = section.id;
                                const numericValue = parseInt(sectionId.match(/\d+/)[0]); // Extract numeric part and convert to integer
                                if (!isNaN(numericValue) && numericValue > highestSectionValue) {
                                    highestSectionValue = numericValue;
                                }
                            });
                            setSectionId(highestSectionValue + 1);
                            serviceInfo.forEach((section) => {
                                section.topics.forEach((topic) => {
                                    const topicId = topic.id;
                                    const numericValue = parseInt(topicId.match(/\d+/)[0]); // Extract numeric part and convert to integer

                                    if (!isNaN(numericValue) && numericValue > highestTopicValue) {
                                        highestTopicValue = numericValue;
                                    }
                                });
                            });
                            setTopicId(highestTopicValue + 1)
                        }

                        if (responseData.variants) {
                            let variantsData = responseData.variants;
                            setValue('variantId', variantsData.id ? variantsData.id : '');
                            setValue('price', variantsData.price ? variantsData.price : '');
                            setValue('comparePrice', (variantsData.compareAtPrice == 0) ? '' : variantsData.compareAtPrice);
                            setValue('taxable', variantsData.taxable ? variantsData.taxable : '');
                            setSelectedCountryOfOrgin(variantsData.countryOfOrgin ? variantsData.countryOfOrgin : '')
                        }
                        if (responseData.categories)
                            setCategories(responseData.categories);
                        if (responseDataDetails.categoryId)
                            setValue('categoryId', responseDataDetails.categoryId);
                        if (responseDataDetails.status != null || responseDataDetails.status != '')
                            setValue('productStatus', responseDataDetails.status);
                    }
                    else {
                        toast.error(t(message));
                        const redirectTimeout = setTimeout(() => {
                            clearTimeout(redirectTimeout);
                            navigate('/services/manage')
                        }, 3000);
                    }
                }
                else {
                    toast.error(t('unableToProccessRequest'));
                    const redirectTimeout = setTimeout(() => {
                        clearTimeout(redirectTimeout);
                        navigate('/services/manage')
                    }, 3000);
                }
            }).catch(error => {
                setIsLoading(false);
                handleErrors(error, t, navigate);
            });
    };

    useEffect(() => {
        if ((addPage && !pageReset)) {    /* To reset the form when navigating from edit page to add page */
            reset();
            setResponseData([]);
            setDescription('');
            setMediaList([]);
            setCustomFields([]);
            setCategoryCustomFields([]);
            setSelectedCustomMultiselect([]);
            setSelectedCountryOfOrgin('');
            setCollections([])
            setCollectionId([]);
            setMediaImages([]);
            setCategories([]);
            setSelectedRow([])
            setShopNameList([]);
            setPageReset(true);
            setSectionLoading(true)
            setSections([
                {
                    id: "section0",
                    title: "",
                    description: "",
                    duration: 0,
                    hidden: false,
                    topics: [{ id: "topic0", title: "", description: "", fileInfo: {}, duration: 0, freePreview: false, hidden: true }]
                }
            ])
            setSectionId(1);
            setTopicId(1);
            fetchProductCreationData();
        }
    })

    useEffect(() => {
        if (!addPage)
            fetchData();
    }, []);

    const handleSelectCollections = (selectedNode) => {
        let ids = [...collectionId];
        if (ids.includes(selectedNode.value))
            ids = ids.filter(item => item !== selectedNode.value);
        else
            ids.push(selectedNode.value)
        setCollectionId(ids);
        setValue('collectionId', ids);
        manipulateDataForDefaultSelected(collections, ids);
    };

    const handleButtonClick = (isSubmit) => {
        if (isSubmit) {
            handleSubmit(onSubmit);
        } else {
            onDraft();
        }
    };

    const submitData = async (inputData) => {

        setIsLoading(true);
        axios.post(BASE + 'api/service/save-service', inputData, {
            headers: {
                Authorization: `Bearer ${TOKEN}`,
                function: Config.FUNCTION_KEY,
            }
        }).then((response) => {
            setIsLoading(false);
            if (response.status == 200) {
                const status = response.data.status;
                const message = response.data.message;
                if (status == 1) {
                    toast.success(t(message))
                    const redirectTimeout = setTimeout(() => {
                        clearTimeout(redirectTimeout);
                        navigate(`/services/manage`);
                    }, 2000);
                }
                else {
                    if (message != '')
                        toast.error(t(message))
                    if (response && response.data && response.data.errors) {
                        const errorData = response.data.errors;
                        errorData.forEach((error) => {
                            setError(error.field, {
                                type: 'server',
                                message: t(error.errors[0])
                            });
                        });
                    }
                }
            }
            else {
                toast.error(t('unableToProccessRequest'));
            }
        }).catch(error => {
            setIsLoading(false);
            handleErrors(error, t, navigate);
        });
    }
    const onDraft = async () => {
        const isValidShopName = await trigger('vendorId')
        const isValidProductName = await trigger('title')
        const isValidPrice = await trigger('price');
        const isValidComparePrice = await trigger('comparePrice');
        const isValidCategoryId = await trigger('categoryId')

        if (isValidShopName && isValidProductName && isValidPrice && isValidComparePrice && isValidCategoryId) {
            let inputData = {};
            inputData.id = product_Id;
            inputData.vendorId = getValues('vendorId');
            inputData.shopName = getValues('shopName');
            inputData.title = getValues('title');
            inputData.description = description;
            inputData.gstSlab = getValues('gstSlab')
            inputData.productTags = getValues('tags');
            inputData.categoryId = getValues('categoryId');
            inputData.images = mediaList;
            inputData.collectionId = collectionId;

            const customFieldData = processCustomFields(
                customFields,
                selectedCustomMultiselect,
                getValues
            );
            inputData.generalCustomFields = customFieldData;

            const categoryCustomFieldsData = processCustomFields(
                categoryCustomFields,
                selectedCustomMultiselect,
                getValues
            );
            inputData.categoryCustomFields = categoryCustomFieldsData;
            inputData.saveType = SERVICE.DRAFT;
            inputData.serviceInfo = sections;

            let list = {};
            list.price = parseFloat(getValues("price"));
            list.compareAtPrice = getValues("comparePrice") ? parseFloat(getValues("comparePrice")) : 0;
            list.countryOfOrgin = selectedCountryOfOrgin;
            list.taxable = getValues("taxable");
            inputData.variants = list;

            submitData(inputData);
        }
    }

    const onSubmit = async (data) => {

        let inputData = {};
        inputData.id = product_Id;
        inputData.vendorId = data['vendorId'];
        inputData.shopName = data['shopName'];
        inputData.title = data['title']
        inputData.description = description
        inputData.gstSlab = data['gstSlab']
        inputData.productTags = data['tags']
        inputData.categoryId = data['categoryId'];
        inputData.images = mediaList;
        inputData.collectionId = collectionId;
        const customFieldData = processCustomFields(
            customFields,
            selectedCustomMultiselect,
            getValues
        );
        inputData.generalCustomFields = customFieldData;

        const categoryCustomFieldsData = processCustomFields(
            categoryCustomFields,
            selectedCustomMultiselect,
            getValues
        );
        inputData.categoryCustomFields = categoryCustomFieldsData;

        inputData.saveType = SERVICE.SUBMIT;

        let list = {};
        list.price = parseFloat(data["price"]);
        list.compareAtPrice = data["comparePrice"] ? parseFloat(data["comparePrice"]) : 0;;
        list.taxable = data["taxable"];
        list.countryOfOrgin = selectedCountryOfOrgin;
        inputData.variants = list;

        let validation = false;

        if (sections && sections.length > 0) {
            setSectionLoading(true)
            const updatedSections = [...sections];
            updatedSections.forEach((section, index) => {
                if (!section.title) {
                    section.title = t('section') + (index + 1);
                }

                if (section.topics && section.topics.length > 0) {
                    section.topics.forEach((topic, topicIndex) => {
                        if (!topic.title) {
                            topic.title = t('topic') + (topicIndex + 1);
                        }

                        if (Object.keys(topic.fileInfo).length === 0) {
                            topic.hidden = false;
                            section.hidden = false;

                        }
                        else {
                            setError(`sections[${index}].topics[${topicIndex}].fileInfo`, {
                                message: ''
                            });
                        }

                    });
                }
            });
            setSections(updatedSections);
            setSectionLoading(false);
            if (validation)
                return;
        }

        inputData.serviceInfo = sections;
        submitData(inputData);
    }

    return (
        <DashboardLayout>
            <DashboardNavbar pageTitle={addPage ? t('addService') : t('editService')} />
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}><CircularProgress color="inherit" /></Backdrop>
            <MDBox mt={3} component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                <Grid item xs={12} md={12} lg={12}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}> {/* service details */}
                                <Card>
                                    <Grid container spacing={2} alignItems="center" sx={{ p: 3 }}>
                                        <Grid item xs={12}>
                                            <MDTypography variant="h6" className="uppercaseLetters">{t('serviceDetails')}</MDTypography>
                                            <MDTypography component="span" variant="body2" >{t('addServiceDetailsHere')}</MDTypography>
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}>
                                            <MDTypography variant="body1" className="labelStyle">{t('sellerShopName')}
                                                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                                            </MDTypography>
                                        </Grid>
                                        <Grid item xs={12} sm={8} md={8}>
                                            {(responseData && responseData.details && responseData.details.vendorShopName) ?
                                                <MDInput
                                                    type="text"
                                                    name="vendorShopName"
                                                    InputProps={{
                                                        classes: { root: "inputBoxStyle" },
                                                    }}
                                                    {...register("vendorShopName", {
                                                    })}
                                                    onChange={((e) => { e.stopPropagation() })}
                                                    disabled
                                                    fullWidth
                                                />
                                                :
                                                <>
                                                    <Autocomplete
                                                        disablePortal
                                                        options={shopNameList}
                                                        className={"autocomplete-styles"}
                                                        getOptionLabel={(option) => option.shopName ? option.shopName : ''}
                                                        loading={loading}
                                                        onChange={(event, newValue) => {
                                                            if (newValue) {
                                                                setValue("vendorId", newValue.id)
                                                                setValue("shopName", newValue.shopName)
                                                            }
                                                        }}
                                                        onInputChange={(event, newInputValue) => {
                                                            handleSearchShopName(newInputValue, setLoading, setShopNameList, t, navigate);
                                                            const shopNameEntry = shopNameList.find(item => item.shopName === newInputValue);
                                                            if (shopNameEntry) {
                                                                setValue("vendorId", shopNameEntry.id);
                                                                setValue("shopName", shopNameEntry.shopName);
                                                            } else {
                                                                setValue("vendorId", "");
                                                                setValue("shopName", "");
                                                            }
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder={t('enterShopName')}
                                                                variant="outlined"
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    classes: { root: "select-input-styles" },
                                                                }}
                                                                fullWidth
                                                            />
                                                        )}
                                                        freeSolo
                                                    />
                                                    <MDInput
                                                        type="hidden"
                                                        name="vendorId"
                                                        value={watch('vendorId') || ''}
                                                        className="sellerShopNameHidden"
                                                        InputProps={{
                                                            classes: { root: "inputBoxStyle" },
                                                        }}
                                                        {...register("vendorId", {
                                                            required: {
                                                                value: true,
                                                                message: t('sellerShopNameRequired')
                                                            }
                                                        })}
                                                        onChange={((e) => { e.stopPropagation() })}
                                                        fullWidth
                                                    />
                                                </>
                                            }
                                            {errors.vendorId && (
                                                <span className="errorMsg FloatRight">{errors.vendorId.message}</span>
                                            )}
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}>
                                            <MDTypography variant="body1" className="labelStyle">{t('serviceName')}
                                                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                                            </MDTypography>
                                        </Grid>
                                        <Grid item xs={12} sm={8} md={8}>
                                            <MDInput
                                                type="text"
                                                name="title"
                                                placeholder={t('enterServiceName')}
                                                InputProps={{
                                                    classes: { root: "inputBoxStyle" },
                                                }}
                                                {...register("title", {
                                                    required: {
                                                        value: true,
                                                        message: t('titleRequired')
                                                    }
                                                })}
                                                onChange={((e) => {
                                                    e.stopPropagation();
                                                    if ((e.target.value).length != 0) {
                                                        setValue('title', (e.target.value).charAt(0).toUpperCase() + (e.target.value).slice(1));
                                                    }
                                                })}
                                                fullWidth />
                                            {errors.title && (<span className="errorMsg FloatRight">{errors.title.message}</span>)}
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}>
                                            <MDTypography variant="body1" className="labelStyle">{t('serviceDescription')}</MDTypography>
                                        </Grid>
                                        <Grid item xs={12} sm={8} md={8}>
                                            {((responseData && responseData.details) || addPage) &&
                                                <MDEditor
                                                    value={description}
                                                    onChange={(updatedContent) => {
                                                        setDescription(updatedContent);
                                                    }}
                                                />}

                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}>
                                            <MDTypography variant="body1" className="labelStyle">{t('serviceTags')}</MDTypography>
                                        </Grid>
                                        <Grid item xs={12} sm={8} md={8}>
                                            <MDInput
                                                type="text"
                                                name="tags"
                                                InputProps={{
                                                    classes: { root: "inputBoxStyle" },
                                                }}
                                                {...register("tags")}
                                                onChange={((e) => { e.stopPropagation() })}
                                                fullWidth />
                                            <MDTypography component="span" variant="body2" color="info">{t('productTagsNotes')}</MDTypography>
                                            {errors.tags && (<span className="errorMsg FloatRight">{errors.tags.message}</span>)}
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}>
                                            <MDTypography variant="body1" className="labelStyle">{t('collections')}</MDTypography>
                                        </Grid>
                                        <Grid item xs={12} sm={8} md={8}>
                                            <TreeSelect data={collections} onSelect={handleSelectCollections} selected={collectionId} />
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>

                            {watch('vendorId') ?
                                <Grid item xs={12} md={12} lg={12}>{/* media */}
                                    <Card >
                                        <Grid container spacing={2} alignItems="center" sx={{ p: 3 }}>
                                            <Grid item xs={12}>
                                                <MDTypography variant="h6" className="uppercaseLetters" >{t('serviceImages')}</MDTypography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <MediaUpload
                                                    mediaList={mediaList}
                                                    mediaLoading={mediaLoading}
                                                    setMediaLoading={setMediaLoading}
                                                    setVariantMediaLoading={setVariantMediaLoading}
                                                    urlPopup={urlPopup}
                                                    imageFrom="service"
                                                    selectedRow={selectedRow}
                                                    product_Id={product_Id}
                                                    vendorId={getValues('vendorId')}
                                                    variantId={''}
                                                    setUrlPopup={setUrlPopup}
                                                    setMediaList={setMediaList}
                                                    setSelectedRow={setSelectedRow}
                                                    register={register}
                                                    watch={watch}
                                                    control={control}
                                                    setValue={setValue}
                                                    getValues={getValues}
                                                    setError={setError}
                                                    trigger={trigger}
                                                    errors={errors}
                                                    setIsLoading={setIsLoading}
                                                    imagePopup={imagePopup}
                                                    mediaImages={mediaImages}
                                                    startIndex={startIndex}
                                                    setStartIndex={setStartIndex}
                                                    setImagePopup={setImagePopup}
                                                    addPage={addPage}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                                :
                                null
                            }
                            <Grid item xs={12}> {/* pricing */}
                                <Card >
                                    <Grid container spacing={2} alignItems="center" sx={{ p: 3 }}>
                                        <Grid item xs={12}>
                                            <MDTypography variant="h6" className="uppercaseLetters"  >{t('GST')}</MDTypography>

                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container spacing={2} alignItems="center">
                                                <Grid item xs={12} sm={4} md={4}>
                                                    <MDTypography variant="body1" className="labelStyle">{t('GSTSlab')}
                                                        <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                                                    </MDTypography>
                                                </Grid>
                                                <Grid item xs={12} sm={8} md={8}>
                                                    <Controller
                                                        name="gstSlab"
                                                        control={control}
                                                        defaultValue={0}
                                                        rules={{
                                                            required: {
                                                                value: true,
                                                                message: t('gstSlabRequired')
                                                            }
                                                        }}
                                                        render={({ field }) => (
                                                            <MDInput
                                                                select
                                                                {...field}
                                                                fullWidth
                                                                InputProps={{
                                                                    classes: { root: "select-input-styles select-padding-0" }

                                                                }}

                                                            >

                                                                <MenuItem key={0} value={0}>
                                                                    {'0%'}
                                                                </MenuItem>
                                                                <MenuItem key={5} value={5}>
                                                                    {'5%'}
                                                                </MenuItem>
                                                                <MenuItem key={12} value={12}>
                                                                    {'12%'}
                                                                </MenuItem>
                                                                <MenuItem key={18} value={18}>
                                                                    {'18%'}
                                                                </MenuItem>
                                                                <MenuItem key={28} value={28}>
                                                                    {'28%'}
                                                                </MenuItem>


                                                            </MDInput>
                                                        )}
                                                    />
                                                    {errors.gstSlab && (
                                                        <span className="errorMsg FloatRight">{errors.gstSlab.message}</span>
                                                    )}

                                                </Grid>

                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>


                            <Grid item xs={12} md={12} lg={12}> {/* pricing */}
                                <Card >
                                    <Grid container spacing={2} alignItems="center" sx={{ p: 3 }}>
                                        <Grid item xs={12}>
                                            <MDTypography variant="h6" className="uppercaseLetters"  >{t('pricing')}</MDTypography>
                                            <MDTypography component="span" variant="body2" >{t('addPricingDetails')}</MDTypography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container spacing={2} alignItems="center">
                                                <Grid item xs={12} sm={4} md={4}>
                                                    <MDTypography variant="body1" className="labelStyle">{t('price')}
                                                        <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                                                    </MDTypography>
                                                </Grid>
                                                <Grid item xs={12} sm={8} md={8}>
                                                    <MDInput
                                                        type="text"
                                                        name="price"
                                                        InputProps={{
                                                            classes: { root: "inputBoxStyle" },
                                                            startAdornment: (
                                                                <InputAdornment position="start"><span>₹</span></InputAdornment>
                                                            ),
                                                        }}
                                                        {...register('price', {
                                                            required: {
                                                                value: true,
                                                                message: t('priceRequired'),
                                                            },
                                                            validate: (value) => {
                                                                if (Number(value) === 0) {
                                                                    return t('invalidInput');
                                                                }
                                                                return true;
                                                            },
                                                        })}
                                                        onChange={e => {
                                                            e.stopPropagation();
                                                            const inputValue = e.target.value.replace(/[^0-9.]/g, "");
                                                            setValue("price", inputValue);
                                                        }}
                                                        placeholder={t('enterPrice')}
                                                        fullWidth
                                                    />
                                                    {errors.price && <span className="errorMsg FloatRight">{errors.price.message}</span>}

                                                </Grid>
                                                <Grid item xs={12} sm={4} md={4}>
                                                    <MDTypography variant="body1" className="labelStyle">{t('comparePrice')}</MDTypography>
                                                </Grid>
                                                <Grid item xs={12} sm={8} md={8}>
                                                    <MDInput
                                                        type="text"
                                                        name="comparePrice"
                                                        InputProps={{
                                                            classes: { root: "inputBoxStyle" },
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <span>₹</span>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                        {...register('comparePrice', {
                                                            validate: (value) => {
                                                                if (value && Number(value) === 0) {
                                                                    return t('invalidInput');
                                                                }
                                                                return true;
                                                            },
                                                        })}
                                                        onChange={e => {
                                                            e.stopPropagation();
                                                            const inputValue = e.target.value.replace(/[^0-9.]/g, "");
                                                            setValue("comparePrice", inputValue);
                                                        }}
                                                        placeholder={t('enterCompareAtPrice')}
                                                        fullWidth
                                                    />
                                                    {errors.comparePrice && (<span className="errorMsg FloatRight">{errors.comparePrice.message}</span>)}
                                                </Grid>
                                                <Grid item xs={12} lg={6} >
                                                    <MDInput
                                                        type="checkbox"
                                                        name="taxable"
                                                        variant="standard"
                                                        InputProps={{
                                                            classes: { root: "inputBoxStyle" },
                                                        }}
                                                        {...register("taxable", {})}
                                                        onChange={e => {
                                                            e.stopPropagation();
                                                        }}
                                                        className="checkboxStyle"
                                                    />
                                                    <MDTypography
                                                        component="span"
                                                        variant="body1"
                                                        className="labelStyle checkboxLabel"
                                                    >
                                                        {t('taxableService')}
                                                    </MDTypography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>

                            <Grid item xs={12} md={12} lg={12}>{/*sections*/}
                                {sectionLoading ?
                                    null
                                    :
                                    <Section
                                        register={register}
                                        setError={setError}
                                        product_Id={product_Id}
                                        setIsLoading={setIsLoading}
                                        vendorId={watch('vendorId')}
                                        sections={sections}
                                        setSections={setSections}
                                        control={control}
                                        errors={errors}
                                        sectionId={sectionId}
                                        setSectionId={setSectionId}
                                        topicId={topicId}
                                        setTopicId={setTopicId}
                                        sectionLoading={sectionLoading}
                                        responseData={responseData}
                                    />
                                }
                            </Grid>
                            <Grid item xs={12} md={12} lg={12}> {/* country of origin */}
                                <CountryOfOrigin
                                    dataFrom="service"
                                    register={register}
                                    errors={errors}
                                    setError={setError}
                                    selectedCountryOfOrgin={selectedCountryOfOrgin}
                                    setSelectedCountryOfOrgin={setSelectedCountryOfOrgin}
                                    isDropdownOpen={isDropdownOpen}
                                    setIsDropdownOpen={setIsDropdownOpen}
                                />
                            </Grid>

                            <Grid item xs={12}>{/*custom fields*/}
                                <CustomFields
                                    dataFrom="service"
                                    customFields={customFields}
                                    control={control}
                                    errors={errors}
                                    categoryCustomFields={categoryCustomFields}
                                    categories={categories}
                                    selectedCustomMultiselect={selectedCustomMultiselect}
                                    setSelectedCustomMultiselect={setSelectedCustomMultiselect}
                                    register={register}
                                    setValue={setValue}
                                    setError={setError}
                                    productId={product_Id}
                                    vendorId={watch('vendorId')}
                                    setCategoryCustomFields={setCategoryCustomFields}
                                    setCustomFields={setCustomFields}
                                    setIsLoading={setIsLoading}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Grid item xs={12} pr={2} className="serviceSubmitButton">
                                    {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("service", "write"))) ?
                                        <>
                                            {((product_Id && watch('productStatus') == 0) || addPage) ?
                                                <MDBox mt={4} mb={4}>
                                                    <MDButton type="button" variant="gradient" color="info" disableRipple onClick={() => handleButtonClick(false)}>{t('draft')}</MDButton>
                                                </MDBox>
                                                : null
                                            }
                                            <MDBox ml={1} mt={4} mb={4}>
                                                <MDButton type="submit" variant="gradient" color="info" disableRipple onClick={() => handleButtonClick(true)}>{t('submit')}</MDButton>
                                            </MDBox>
                                        </>
                                        : null
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </MDBox>
                </Grid >
            </MDBox>
        </DashboardLayout >

    )
}
export default Service;
